var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.663 2.66927C11.9221 2.66927 12.0822 2.95193 11.9489 3.1741L10.292 5.93541C10.6851 6.15717 11.0428 6.43427 11.3545 6.75612L13.0922 3.86011C13.7587 2.74923 12.9585 1.33594 11.663 1.33594H10.0748C9.38526 1.33594 8.74432 1.69118 8.37884 2.27594L7.60938 3.50709L8.39554 4.76495L9.50951 2.9826C9.63133 2.78768 9.84498 2.66927 10.0748 2.66927H11.663Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04747 3.1741C3.91417 2.95193 4.0742 2.66927 4.3333 2.66927H5.928C6.15786 2.66927 6.37151 2.78768 6.49333 2.98261L7.96425 5.33608C7.97638 5.33598 7.98851 5.33594 8.00065 5.33594C8.61842 5.33594 9.20814 5.45597 9.74778 5.674L7.624 2.27594C7.25852 1.69118 6.61758 1.33594 5.928 1.33594H4.3333C3.03782 1.33594 2.23763 2.74921 2.90414 3.86009L4.64425 6.76032C4.95566 6.43802 5.31307 6.16045 5.70589 5.93818L4.04747 3.1741Z",
    fill: "#FF865C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 10.0026C9.33594 10.739 8.73898 11.3359 8.0026 11.3359C7.26622 11.3359 6.66927 10.739 6.66927 10.0026C6.66927 9.26622 7.26622 8.66927 8.0026 8.66927C8.73898 8.66927 9.33594 9.26622 9.33594 10.0026Z",
    fill: "#FF865C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6693 10.0026C12.6693 12.5799 10.5799 14.6693 8.0026 14.6693C5.42528 14.6693 3.33594 12.5799 3.33594 10.0026C3.33594 7.42528 5.42528 5.33594 8.0026 5.33594C10.5799 5.33594 12.6693 7.42528 12.6693 10.0026ZM11.3359 10.0026C11.3359 11.8436 9.84355 13.3359 8.0026 13.3359C6.16166 13.3359 4.66927 11.8436 4.66927 10.0026C4.66927 8.16166 6.16166 6.66927 8.0026 6.66927C9.84355 6.66927 11.3359 8.16166 11.3359 10.0026Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/Medal.b1eb661bf046c397f32715436d7c57e7.svg";
export { ForwardRef as ReactComponent };